const mediaItems = [
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Youtube%20video%20thumbnail%20style%20with%20dramatic%20red%20alert%20breaking%20news%20text%20overlay%2C%20dark%20warm%20background%20with%20glowing%20accents%2C%20vlog%20style%20composition&width=640&height=360&seq=media-thumb-01&orientation=landscape',
    title: '明星塌房全记录：2026上半年娱乐圈大地震',
    duration: '15:28',
    views: '89万',
    tag: '年度盘点',
  },
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20with%20live%20streaming%20studio%20setup%20and%20dramatic%20warm%20lighting%2C%20social%20media%20influencer%20style%2C%20editorial%20news%20format&width=640&height=360&seq=media-thumb-02&orientation=landscape',
    title: '网红翻车名场面TOP10：一个比一个离谱',
    duration: '12:06',
    views: '156万',
    tag: '搞笑合集',
  },
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Professional%20video%20thumbnail%20with%20red%20carpet%20event%20scene%2C%20dramatic%20golden%20lighting%2C%20celebrity%20interview%20style%2C%20editorial%20quality&width=640&height=360&seq=media-thumb-03&orientation=landscape',
    title: '红毯翻车大赏：那些年明星们的社死瞬间',
    duration: '08:45',
    views: '203万',
    tag: '娱乐盘点',
  },
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Documentary%20style%20video%20thumbnail%20about%20social%20media%20scandal%2C%20investigative%20journalism%20aesthetic%2C%20dramatic%20warm%20tone%2C%20editorial%20quality&width=640&height=360&seq=media-thumb-04&orientation=landscape',
    title: '深度扒皮：MCN机构的流量造假产业链',
    duration: '22:30',
    views: '67万',
    tag: '深度调查',
  },
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20of%20celebrity%20gossip%20reaction%20format%2C%20dramatic%20warm%20red%20and%20gold%20visual%20style%2C%20talk%20show%20aesthetic&width=640&height=360&seq=media-thumb-05&orientation=landscape',
    title: '吃瓜群众反应合集：每条爆料下的神评论',
    duration: '06:18',
    views: '312万',
    tag: '热门互动',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 text-center mb-2">精彩视频</h2>
        <p className="text-foreground-500 text-sm text-center mb-8">热门爆料视频合集，点击即可观看</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.slice(0, 3).map((item) => (
            <a
              key={item.title}
              href="#media"
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="aspect-video overflow-hidden bg-background-200 relative">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-foreground-900/20 group-hover:bg-foreground-900/30 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform duration-200">
                    <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-foreground-900/70 text-background-50 text-[10px] whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 mt-2">
                  <span className="text-[11px] text-primary-500 bg-primary-50 px-1.5 py-0.5 rounded whitespace-nowrap">{item.tag}</span>
                  <span className="text-xs text-foreground-400">{item.views} 播放</span>
                </div>
              </div>
            </a>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {mediaItems.slice(3).map((item) => (
            <a
              key={item.title}
              href="#media"
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="sm:w-[240px] aspect-video sm:aspect-auto overflow-hidden bg-background-200 relative shrink-0">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-foreground-900/20 flex items-center justify-center">
                  <div className="w-10 h-10 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform duration-200">
                    <i className="ri-play-fill text-primary-500 text-lg ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-foreground-900/70 text-background-50 text-[10px] whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4 flex flex-col justify-center min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 mt-2">
                  <span className="text-[11px] text-primary-500 bg-primary-50 px-1.5 py-0.5 rounded whitespace-nowrap">{item.tag}</span>
                  <span className="text-xs text-foreground-400">{item.views} 播放</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}